// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"01ff812e","239":"38efcd0f","453":"d3f25aac","732":"0b802dce"}[chunkId] + ".chunk.js";
};